<template>
  <div id="wave">
    <img class="wave1" :style="{top:(100-percent)+'%'}" src="static/wave.png"/>
    <img class="wave2" :style="{top:(100-percent)+'%'}" src="static/wave.png"/>
    <img class="wave3" :style="{top:(100-percent)+'%'}" src="static/wave.png"/>
    <img class="glass" src="static/glass.png"/>
    <div class="text">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props:['percent'],
  data() {
    return {
      top:80
    }
  },
}
</script>
<style>
#wave {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  border: solid 1px #283b98;
}
#wave .wave1 {
  position: absolute;
  top: 100px;
  left: 0;
  animation: rotate 30s linear infinite;
  z-index: 3;
}
#wave .wave2 {
  position: absolute;
  top: 100px;
  right: 0;
  animation: rotate2 28s linear infinite;
  z-index: 2;
  opacity: 0.4;
}
#wave .wave3 {
  position: absolute;
  top: 100px;
  right: 100px;
  animation: rotate3 40s linear infinite;
  z-index: 1;
  opacity: 0.5;
}
#wave .text {
  position: relative;
  top: 0;
  right: 0;
  z-index: 4;
}
#wave .glass {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
  width: 100%;
  opacity: 0.5;
}
@keyframes rotate {
  50% {
    left: -600px;
  }
  100% {
    left: -1020px;
  }
}
@keyframes rotate2 {
  50% {
    right: -600px;
  }
  100% {
    right: -1020px;
  }
}
@keyframes rotate3 {
  50% {
    right: -400px;
  }
  100% {
    right: -800px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/qiuqiu.vue